// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__2huXz","dragIcon":"Choice_dragIcon__RjeEt","left":"Choice_left__Rz7kz","input":"Choice_input__1UaZp"};